import { nanoid } from 'nanoid'
export default function createItems (array) {
    const item = array.map(({name, country, birthYear, deathYear, style, image}) => {
        return `  <li id="${nanoid(3)}">
                <img src="${image}">
                <h2>${name}</h2>
                <h3>${country}</h3>
                <p>${birthYear}</p>
                <p>${deathYear}</p>
                <p>${style}</p>
            </li>`
    }).join("")
    return item
}